export default function Disclaimer() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <h2>Disclaimer</h2>
          <p>
            Use this resource responsibly. We always advocate for reading the original research
            studies yourself, drawing your own conclusions, and determining any applicable changes
            to your practice. By reading the content of this website, you agree not to use this blog
            or podcast as medical advice for healthcare providers or for patients. This resource
            should not be used in any legal capacity whatsoever. No guarantee is given regarding the
            accuracy of any statements or opinions made on the podcast or the blog. This entire
            disclaimer applies to any and all content on this website. Under no circumstances shall
            any of the contributors on this website be responsible for damages arising from the use
            of this website. This blog and podcast are the opinions of its authors and do not
            represent the views or opinions of any medical institution or employer.
          </p>
        </div>
      </div>
    </div>
  );
}
